import React, { createContext, useContext, useState, useCallback } from "react";

const RegionContext = createContext(null);

export const REGIONS = {
  global: { key: "global", label: "Global", currency: "USD", symbol: "$", flag: "🌐", home: "/" },
  MY: { key: "MY", label: "Malaysia", currency: "MYR", symbol: "RM ", flag: "🇲🇾", home: "/my" },
};

export function RegionProvider({ children }) {
  const [region, setRegionState] = useState(
    () => localStorage.getItem("po_region") || "global"
  );

  const setRegion = useCallback((r) => {
    if (!REGIONS[r]) return;
    localStorage.setItem("po_region", r);
    setRegionState(r);
  }, []);

  const cfg = REGIONS[region] || REGIONS.global;

  return (
    <RegionContext.Provider value={{ region, setRegion, cfg }}>
      {children}
    </RegionContext.Provider>
  );
}

export function useRegion() {
  return useContext(RegionContext) || { region: "global", setRegion: () => {}, cfg: REGIONS.global };
}
